import React from 'react';
import { Drawer } from 'antd';
import Company from './Company';
import { UserOutlined } from '@ant-design/icons';

const MapDrawer = ({ isOpen, onClose, title, items }) => {
    const itemCount = items ? items.length : 0;

    return (
        <Drawer
            title={title}
            placement="right"
            closable={true}
            onClose={onClose}
            open={isOpen}
            style={{ margin: 0 , padding: 0 }}
        >
            {items && items.map((item, index) => (
                <Company key={item.id || index} item={item} />
            ))}
            {itemCount > 1 && (
                <p style={{
                    position: 'absolute',
                    top: 16,
                    right: 16,
                    zIndex: 1  // Ensure it is above all other content
                }}>
                <UserOutlined /> {itemCount}
                </p>
            )}
        </Drawer>
    );
};

export default MapDrawer;
